import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=6ad7e1a0&"
import script from "./GanttChart.vue?vue&type=script&lang=js&"
export * from "./GanttChart.vue?vue&type=script&lang=js&"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=6ad7e1a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports